import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SendingFileUpload } from 'src/modules/sending/components/sendingFileUpload';

const SendingAttachmentForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <Grid item xs={12}>
        <Typography variant='body2'>{t('common:sendingAttachmentForm')}</Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        <SendingFileUpload saveFace />
      </Grid>
    </>
  );
};

export default SendingAttachmentForm;
